import { Router } from '@angular/router';
import { ActiveDevice, KycStatus, KycStatusRoutingConfig } from '@finxone-platform/shared/sys-config-types';
import { DeviceTypeService } from '../services/device-type/device-type.service';

export function handlePostLoginRetailUserRouting(
  kycStatusRoutingConfig: KycStatusRoutingConfig,
  router: Router,
  kycVerificationStatus = '',
  deviceTypeService?: DeviceTypeService,
): boolean {
  const deviceType = deviceTypeService?.currentdeviceType as ActiveDevice;
  const retailConfig = kycStatusRoutingConfig?.retail[deviceType];

  if (!retailConfig) return false;

  if (kycVerificationStatus === KycStatus.PENDING && retailConfig?.pending) {
    router.navigateByUrl(retailConfig?.pending);
    return true;
  }

  if (kycVerificationStatus === KycStatus.SUCCESS && retailConfig?.approved) {
    router.navigateByUrl(retailConfig?.approved);
    return true;
  }

  if (kycVerificationStatus === KycStatus.CANCELLED && retailConfig?.canceled) {
    router.navigateByUrl(retailConfig?.canceled);
    return true;
  }

  if (kycVerificationStatus === KycStatus.FAILED && retailConfig?.failed) {
    router.navigateByUrl(retailConfig?.failed);
    return true;
  }

  if (retailConfig?.default) {
    router.navigateByUrl(retailConfig?.default);
    return true;
  }

  return false;
}
